export const getUserAgent = () => window.navigator ? navigator.userAgent.toLowerCase() : '';